import styled from 'styled-components'

export const ColumnsContainer = styled.div<{quantityGrid: number}>`
  display: grid;
  grid-template-columns: ${props => `repeat(${props.quantityGrid}, 1fr)`};
  margin-top: 30px;
  width: 100%;
  overflow-x: auto;

  ::-webkit-scrollbar {
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const MinAndMaxContainer = styled.div<{position?: 'first' | 'last'}>`
  display: flex;
`

export const ColumnInput = styled.input<{position?: 'first' | 'last', outOfNorm?: boolean}>`
  ${props => props.outOfNorm ? `
    background-color: #FFFCEE;
    color: #9D7D07;
    ::placeholder {
      color: #9D7D07;
    }
  ` : `
    background-color: #F4F4F4;
  `}
  height: 40px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 .5rem;
  border: none;
  outline: none;
  min-width: 8rem;
  text-align: end;

  ${props => props.position === 'first' && `
    border-radius: 8px 0 0 8px;
  `}
  ${props => props.position === 'last' && `
    border-radius: 0 8px 8px 0;
  `}

  :focus {
    border: 1px solid #696969;
  }
`

export const ColumnLabel = styled.label<{isItLast?: boolean}>`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #696969;
  padding: 1rem;
  border-right: ${props => props.isItLast ? 'none' : '1px solid #EBEBEB'};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  height: 5rem;
`